<template>
  <div>
    <div class="header">
      <div class="topbar">
        <topbar />
      </div>
      <div>
        <search />
      </div>
      <div>
        <cart-side />
      </div>
    </div>
    <div>
      <app-nav />
    </div>
    <div class="banner">
      <slide-img :imgs="imgs" class="banner-slideshow" />
    </div>
    <div v-if="isShow">
      <div class="content-type" style="margin-top:40px">联盟会员</div>
      <div v-if="shops.length>0" class="shops">
        <slide-showShops :shops="shops" />
      </div>
      <div>
        <div />
      </div>
      <div class="content-type" style="margin-bottom:30px">品牌厂家</div>
      <b-link class="more" to="/manufacturer">更多</b-link>
      <div class="manufacturers">
        <div v-for="(manufacturer,index) in manufacturers" :key="index">
          <manufacturer :manufacturer="manufacturer" />
        </div>
      </div>
      <div class="content-type" style="margin-top:40px;margin-bottom:30px">热销产品</div>
      <div class="items">
        <div v-for="(item,index) in items" :key="index" class="item" @click="goto(item.id)">
          <item :item="item" />
        </div>
      </div>
    </div>
    <div>
      <app-footer />
    </div>
  </div></template>
<script>
import CartSide from './CartSide'
import footer from '@/components/Footer.vue'
import topbar from '@/components/TopBar.vue'
import search from '@/components/Search.vue'
import nav from '@/components/Nav.vue'
import { ShopService } from '@/service/ShopService'
import { ManufacturerService } from '@/service/ManufacturerService'
import { ItemService } from '@/service/ItemService'
import item from './Item.vue'
import slideshowImg from './SlideShowImgTwo.vue'
import manufacturer from './Manufacturer.vue'
import slideShowShops from './SlideShowShops.vue'
export default {
  components: {
    search, topbar, 'app-nav': nav, 'app-footer': footer,
    'slide-showShops': slideShowShops, 'cart-side': CartSide,
    'slide-img': slideshowImg,
    manufacturer,
    item
  },
  data () {
    return {
      isShow: true,
      imgs: [
        require('../../../static/images/index_banner.jpg'),
        require('../../../static/images/banner0309_1.jpg'),
        require('../../../static/images/banner0309_2.jpg'),
        require('../../../static/images/b1.jpg'),
        require('../../../static/images/b2.jpg')
      ],
      items: [],
      shops: [],
      ItemsIds: [],
      disShops: [],
      manufacturers: []
    }
  },
  mounted () {
    this.getShop()
    this.getManufacturer()
    this.getItems()
  },
  methods: {
    getShop () {
      // 请求店铺信息
      this.shops = []
      var data = {
        unionId: this.$store.getters.unionId
      }
      var shopService = new ShopService(this.$axios)
      shopService.loadShops(data).then(res => {
        res.forEach(shop => {
          this.shops.push(shop)
        })
        console.log('this.shops______', this.shops)
      })
    },
    goto (itemId) {
      this.$router.push({ path: '/item', query: { id: itemId }})
    },
    getManufacturer () {
      // 请求厂商信息
      this.manufacturers = []
      var data = {
        unionId: this.$store.getters.unionId
      }
      var manufacturerService = new ManufacturerService(this.$axios)
      manufacturerService.loadManufacturer(data).then(res => {
        res.forEach(tmpManufacturer => {
          this.manufacturers.push(tmpManufacturer)
        })
        if (this.manufacturers.length > 10) {
          console.log(this.manufacturers.length)
          this.manufacturers.splice(10)
        }
      })
    },
    getItems () {
      // 请求商品展示列表
      this.items = []
      this.ItemsIds = []
      var data = {
        type: -1,
        floorType: 1,
        isShow: 0
      }
      var itemService = new ItemService(this.$axios)
      itemService.loadIndexItem(data).then(res => {
        console.log('sdaa++++++', res)
        res.forEach(tmpItem => {
          if (tmpItem.commonName !== null && tmpItem.commonName.length > 7) {
            tmpItem.commonName = tmpItem.commonName.slice(0, 7) + '...'
          }
          if (tmpItem.shopName !== null && tmpItem.shopName.length > 11) {
            tmpItem.shopName = tmpItem.shopName.slice(0, 11) + '...'
          }
          if (tmpItem.manufacturer !== null && tmpItem.manufacturer.length > 19) {
            tmpItem.manufacturer = tmpItem.manufacturer.slice(0, 19) + '...'
          }
          if (tmpItem.norm !== null && tmpItem.norm.length > 15) {
            tmpItem.norm = tmpItem.norm.slice(0, 15) + '...'
          }
          this.ItemsIds.push(tmpItem.id)
          this.items.push(tmpItem)
        })
        if (this.items.length > 12) {
          console.log(this.manufacturers.length)
          this.ItemsIds.splice(12)
          this.items.splice(12)
        }

        this.resetItem()
      })
    },
    resetItem () {
      // 重新给商品信息赋值
      console.log('resetItem____')
      var itemService = new ItemService(this.$axios)
      itemService.loadFullInfo(this.ItemsIds).then(res => {
        console.log(res, '++++++++res')
        const itemMap = new Map()
        res.forEach(tmpItem => {
          itemMap.set(tmpItem.id, tmpItem)
        })
        this.items.forEach(tmpItem => {
          if (tmpItem.id === itemMap.get(tmpItem.id).id) {
            tmpItem.showPrice = '￥' + itemMap.get(tmpItem.id).showPrice.toFixed(2)
          }
        })
      })
    }
  }
}
</script>
<style scoped>
.topbar{
  width: 100%;
  background-color: #e3e4e5
}
.banner {
  width: 1200px;
  height: 300px;
  margin: 0 auto;
}
.banner-slideshow {
  display: inline-block;
}
.content-type {
  font-size: 24px;
  font-weight: 800;
}
.shops {
  width: 1300px;
  margin: -50px auto 0px;
}
.manufacturer {
  margin-left: 33px;
  margin-top: 10px;
  height: 100px;
  width: 200px;
  border: 5px solid #d7d7d7;
}
.manufacturers {
  display: flex;
  flex-wrap: wrap;
  width: 1200px;
  margin: -15px auto 10px;
}
.items {
  width: 1170px;
  margin: 0 auto;
  display: flex;
  flex-wrap: wrap;
}
.item {
  margin-left: 18px;
  margin-top: 10px;
  cursor: pointer;
}
.more{
  cursor:pointer;
  position: relative;
  bottom: 60px;
  left: 550px;
  font-size: 16px;
  color: #006cff;
}
.more:hover{
  cursor:pointer;
  text-decoration:underline
}
</style>
